var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-rate-wrapper",class:[_vm.colorRender(_vm.num)]},_vm._l((4),function(key){return _c('span',{key:key,staticClass:"star",class:_vm.starRender(_vm.num, key)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }